import images from "./images";

const gallery = [
  {
    id: 1,
    image: images.coffee1,
    title: 'Guatemalan',
    category: 'hot coffee',
  },
  {
    id: 2,
    image: images.drink1,
    title: 'Iced Coffee',
    category: 'cold drinks',
  },
  {
    id: 3,
    image: images.dessert1,
    title: 'Croissant',
    category: 'pastries',
  },
  {
    id: 4,
    image: images.coffee2,
    title: 'Colombian',
    category: 'hot coffee',
  },
  {
    id: 5,
    image: images.drink2,
    title: 'Ice Tea',
    category: 'cold drinks',
  },
  {
    id: 7,
    image: images.coffee3,
    title: 'Black Knight',
    category: 'hot coffee',
  },
  {
    id: 8,
    image: images.drink3,
    title: 'Smoothie',
    category: 'cold drinks',
  },
];

export default gallery;
